export enum TabTypes { config = 'config', edit = 'edit' }